import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import registerFormSlice from "./slicer/registerFormSlice";
import tokenSlice from "./slicer/tokenSlice";
import resetPasswordFormSlice from "./slicer/resetPasswordFormSlice";
import tokenVerificationSlice from "./slicer/tokenVerificationSlice";
import GestioneUsersSlice from "./slicer/GestioneUsersSlice";
import ProfiloSlice from "./slicer/ProfiloSlice";
import FormLoginValidationSlice from "./slicer/FormLoginValidationSlice";
import FormAddUserValidationSlice from "./slicer/FormAddUserValidationSlice";
import FormTopicValidationSlice from "./slicer/FormTopicValidationSlice";
import GestioneSourcesSlice from "./slicer/GestioneSourcesSlice";
import FormAddSourceValidationSlice from "./slicer/FormAddSourceValidationSlice";
import GestioneProjectsSlice from "./slicer/GestioneProjectsSlice";
import GestioneChatSlice from "./slicer/GestioneChatSlice";
import GestioneDetailProjectSlice from "./slicer/GestioneDetailProjectSlice";
import GestioneCodeSlice from "./slicer/GestioneCodeSlice";
import GestioneSourceSlice from "./slicer/GestioneSourceSlice";
import GestioneSaveAnswerSlice from "./slicer/GestioneSaveAnswerSlice";
import GestioneTopicsSlice from "./slicer/GestioneTopicsSlice";
import GestioneReportSlice from "./slicer/GestioneReportSlice";
import CheckOpenedReportSlice from "./slicer/CheckOpenedReportSlice";

const store = configureStore({
  reducer: {
    registerFormSlice: registerFormSlice,
    tokenSlice: tokenSlice,
    resetPasswordFormSlice: resetPasswordFormSlice,
    tokenVerificationSlice: tokenVerificationSlice,
    gestioneUsersSlice: GestioneUsersSlice,
    profiloSlice: ProfiloSlice,
    formLoginValidationSlice: FormLoginValidationSlice,
    formAddUserValidationSlice: FormAddUserValidationSlice,
    formTopicValidationSlice: FormTopicValidationSlice,
    gestioneSourcesSlice: GestioneSourcesSlice,
    gestioneProjectsSlice: GestioneProjectsSlice,
    gestioneDetailProjectSlice: GestioneDetailProjectSlice,
    formAddSourceValidationSlice: FormAddSourceValidationSlice,
    gestioneChatSlice: GestioneChatSlice,
    gestioneCodeSlice: GestioneCodeSlice,
    gestioneSourceSlice: GestioneSourceSlice,
    gestioneSaveAnswerSlice: GestioneSaveAnswerSlice,
    gestioneTopicsSlice: GestioneTopicsSlice,
    gestioneReportSlice: GestioneReportSlice,
    checkOpenedReportSlice: CheckOpenedReportSlice,
  },
});

export default store;

type AppDispatch = typeof store.dispatch;
type RootState = ReturnType<typeof store.getState>;

// Use throughout your app instead of plain useDispatch and useSelector
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
